import { render, staticRenderFns } from "./PatientRoutePage.vue?vue&type=template&id=93ce1404&"
import script from "./PatientRoutePage.vue?vue&type=script&lang=js&"
export * from "./PatientRoutePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports